export const clientIds = {
  smartr365: 'Smartr365',
  simplyBiz: 'SimplyBiz',
};
